import { Translation } from '@it/orpk-vue-ts'

export default Translation.vxe
